import ProductSkeleton from '@/components/sections/products/skeleton/ProductSkeleton';
import {ProductsPaginatedTake} from '@/libs/constants/common.constants';
import ProductSkeletonGrid from '@/components/sections/products/skeleton/ProductSkeletonGrid';

export default function ProductSkeletonList({ isGrid = false }) {
	if (isGrid) {
		return (
				Array.from({length: ProductsPaginatedTake}).map((_, index) => (
						<div className="col-xl-4 col-sm-6 col-6" key={index}>
							<ProductSkeletonGrid/>
						</div>
				))
		)
	}
	return (
			Array.from({length: ProductsPaginatedTake}).map((_, index) => (
					<div className="col-lg-12" key={index}>
						<ProductSkeleton/>
					</div>
			))
	);
}
